import { useState, useCallback } from 'react';
import { Node, Edge } from 'reactflow';

interface HistoryItem {
  nodes: Node[];
  edges: Edge[];
}

export const useUndoRedo = () => {
  const [past, setPast] = useState<HistoryItem[]>([]);
  const [future, setFuture] = useState<HistoryItem[]>([]);

  const takeSnapshot = useCallback((nodes: Node[], edges: Edge[]) => {
    setPast((old) => [...old, { nodes, edges }]);
    setFuture([]);
  }, []);

  const undo = useCallback(
    (currentNodes: Node[], currentEdges: Edge[]) => {
      if (past.length === 0) return null;

      const previous = past[past.length - 1];
      const newPast = past.slice(0, past.length - 1);

      setPast(newPast);
      setFuture((old) => [{ nodes: currentNodes, edges: currentEdges }, ...old]);

      return previous;
    },
    [past]
  );

  const redo = useCallback(
    (currentNodes: Node[], currentEdges: Edge[]) => {
      if (future.length === 0) return null;

      const next = future[0];
      const newFuture = future.slice(1);

      setPast((old) => [...old, { nodes: currentNodes, edges: currentEdges }]);
      setFuture(newFuture);

      return next;
    },
    [future]
  );

  const clearHistory = useCallback(() => {
    setPast([]);
    setFuture([]);
  }, []);

  return {
    takeSnapshot,
    undo,
    redo,
    canUndo: past.length > 0,
    canRedo: future.length > 0,
    clearHistory,
  };
};

